// src/Pages/Combos.js
import React from 'react';
import Button from '../Components/Button';
import Layout from '../Components/Layout/Layout';
import SectionCombo from '../Components/Sections/SectionCombo/SectionCombo';

import './Combos.scss';

function Combos() {
  return (
    <Layout>
        <div className='combos'>
          <SectionCombo />
        </div>
    </Layout>
  );
}

export default Combos;

